import React, { createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'interfaces';
import { deleteToken } from 'firebase/messaging';
import { messaging, requestForToken } from 'firebaseInit';
import { hasNotificationsService } from 'pages/PageMyNotificationList/api';
import { hasNotificationsPpr } from 'pages/PageMyNotificationPprList/api';
import { updateFirebaseToken } from 'api';

export interface NotificationsProviderProps {
  hasNotifications?: boolean;
  checkNotifications({ service, ppr }: { service?: boolean; ppr?: boolean }): void;
  checkAllNotifications(): void;
}

export const NotificationsContext = createContext<NotificationsProviderProps>({
  hasNotifications: false,
  checkNotifications() {},
  checkAllNotifications() {},
});

const NotificationsProvider: React.FC = ({ children }) => {
  const user = useSelector((state: RootState) => state.user);

  const [hasNotifications, setHasNotifications] = useState<{ service?: boolean; ppr?: boolean }>({
    service: false,
    ppr: false,
  });

  function checkNotifications({ service = false, ppr = false }: { service?: boolean; ppr?: boolean }) {
    setHasNotifications({ service, ppr });
  }

  async function checkAllNotifications() {
    setHasNotifications({
      ppr: (await hasNotificationsPpr()).hasNotView,
      service: (await hasNotificationsService()).hasNotView,
    });
  }

  useEffect(() => {
    if (!Object.keys(user).length) return;

    requestForToken()
      .then((token) =>
        updateFirebaseToken(token).catch(() => {
          deleteToken(messaging).then(() => {
            requestForToken().then(updateFirebaseToken);
          });
        }),
      )
      .catch(() => {});
    checkAllNotifications();
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <NotificationsContext.Provider
      value={{
        hasNotifications: Object.values(hasNotifications).some((value) => Boolean(value)),
        checkNotifications,
        checkAllNotifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export default NotificationsProvider;
